<template>
<v-card flat color="grey lighten-5">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-layout row wrap>
        <v-toolbar class="baslik" size="120px" dark color="info">
            <v-toolbar-title class="baslikfont"> {{ $t('current_index_header') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field :label="$t('current_index_searc_label')" flat="" solo-inverted="" hide-details append-icon="search" v-model="Query.q"></v-text-field>
            &nbsp;
            <v-tooltip bottom>
                <v-icon slot="activator" dark @click="filtrele()">filter_list</v-icon>
                <span>{{$t('Add-Search-Filter')}}</span>
            </v-tooltip>

            <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="yeniekle()" flat> <span class="hidden-sm-and-down"> {{$t('current_index_addbuton_label')}}
                    </span>
                    <v-icon right dark>add_box</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t('current_index_addbuton_label')}}</span>
            </v-tooltip>

            <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                    <v-icon>more_vert</v-icon>
                </v-btn>

                <v-list>

                    <v-list>
                        <a target="_self" v-bind:href="'#/cari/carikartgenelamaclirapor/'">
                            <v-list-tile>
                                <v-list-tile-title> {{$t('Current-Card-General-Purpose-Report')}} </v-list-tile-title>
                            </v-list-tile>
                        </a>
                    </v-list>
                    <v-tooltip bottom>

                        <v-list-tile slot="activator" :disabled="!sayfayetki.Delete" @click="tumkayitlar()">
                            <v-list-tile-title>{{$t('all_records')}}</v-list-tile-title>
                        </v-list-tile>
                        <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                        <span v-if="sayfayetki.Delete">{{$t('all_records')}}</span>
                    </v-tooltip>

                    <v-list-tile v-if="this.PB=='TRY'" @click="efaturaSorgula()">
                        <v-list-tile-title>{{ $t('E-Invoice-Liable-Inquiry') }}</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-toolbar>
        <v-layout row wrap>
            <v-container fluid="">
                <v-layout row="" wrap="">
                    <v-flex pa-1 xs12 sm12>
                        <v-alert :value="true" color="white" icon="info">
                            <span class="subheading grey--text"> {{toplamkayit}} </span>
                        </v-alert>
                    </v-flex>

                    <v-flex pa-1 xs12 sm6 md4 v-for="item in Currents" v-bind:key="item.index">
                        <v-hover>
                            <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" class="mx-auto" width="100%">
                                <a target="_blank" v-bind:href="'#/cari/goster/'+ item.Code.replace('/','%2f')">
                                    <v-card flat="" class="grey--text">
                                        <v-layout>
                                            <v-flex xs3>
                                                <img v-show="item.MusteriTipi=='K'" height="95%" width="95%" style=" padding-left:10%; padding-top:10%;" src="../../../assets/images/business.png">
                                                <img v-show="item.MusteriTipi!='K'" height="95%" width="95%" style=" padding-left:15%; padding-top:15%;" src="../../../assets/images/person.png">
                                            </v-flex>
                                            <v-flex xs9>
                                                <v-card-title primary-title>
                                                    <v-list-tile-title>
                                                        <span class="body-1 grey--text font-weight-">
                                                            {{item.Code}}
                                                        </span>
                                                    </v-list-tile-title>
                                                    <v-list-tile-title>
                                                        <span class="body-1 font-weight-">
                                                            {{item.Title}}
                                                        </span>
                                                    </v-list-tile-title>

                                                </v-card-title>
                                                <v-layout justify-start>
                                                <v-list-tile v-if="item.Kapali">
                                                    <v-chip label color="red" text-color="white">
                                                        <v-icon left color="#FFFFFF">disabled_by_default</v-icon>{{$t('Dec-activated-Current') }}
                                                    </v-chip>
                                                </v-list-tile>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider light></v-divider>
                                        <v-flex xs12 sm12>
                                            <v-list>
                                                <v-list-tile>
                                                    <v-list-tile-action>
                                                        <v-icon color="grey">phone</v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-content>
                                                        <v-list-tile-title> <span class="body-1 font-weight-light"> {{item.Phone}}</span>
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                                <v-divider inset></v-divider>
                                                <v-list-tile>
                                                    <v-list-tile-action>
                                                        <v-icon color="grey">location_on</v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>
                                                            <span class="body-1 font-weight-light"> {{item.Address}}</span>
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                            </v-list>
                                        </v-flex>
                                    </v-card>
                                </a>
                            </v-card>
                        </v-hover>
                    </v-flex>

                </v-layout>
            </v-container>

            <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
                <v-card color="grey lighten-5">

                    <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>

                        <v-layout row="" wrap="">
                            <div class="flex md12">
                             <cariaracomp v-bind:etiket="$t('Select-Starting-Current')" :loading="loadingcaribas" v-bind:value="Current.Filters.BaslangicCari" v-model="Current.Filters.BaslangicCari"></cariaracomp>

                             <cariaracomp v-bind:etiket="this.$t('Select-Ending-Current')" :loading="loadingcaribit" v-bind:value="Current.Filters.BitisCari" v-model="Current.Filters.BitisCari"></cariaracomp>

                             <cariaracomp v-bind:etiket="$t('Main-Account')" :loading="loadingcariana" v-bind:value="Current.Filters.AnaHeseap" v-model="Current.Filters.AnaHeseap"></cariaracomp>


                                <v-autocomplete hide-details clearable :items="hesapgurubu" v-model="Current.Filters.HesapGrubu" :label="$t('Account-Group')" multiple item-text="Title" item-value="Kod">
                                    <template slot="selection" slot-scope="{ item, index }">
                                        <v-chip v-if="index === 0">
                                            <h4> <span>{{ item.Kod }}</span> </h4>
                                        </v-chip>
                                        <span v-if="index === 1" class="grey--text caption">(+{{
                                 Current.Filters.HesapGrubu.length - 1 }} {{ $t('other-record') }})</span>
                                    </template>
                                </v-autocomplete>
                                <v-autocomplete hide-details clearable v-model="Current.Filters.AnalizKodu" :items="analiz" :label="$t('Analysis-Code')" item-text="AnalizAdi" item-value="AnalizKod" max-height="400">
                                </v-autocomplete>

                                <v-autocomplete hide-details :items="masrafmerkezi" clearable v-model="Current.Filters.Masraf" :label="$t('Expense-Center-v2')" item-text="Title" item-value="Code">
                                </v-autocomplete>

                                <v-select hide-details v-model="Current.Filters.CariTip" :items="musteritipi" :label="$t('Current-Type')" item-text="text" item-value="value">
                                </v-select>

                                <div class="flex md12">
                                    <v-checkbox :label="$t('Account-Group-Empty-Ones')" v-model="Current.Filters.HesapGrupBos" hide-details="">
                                    </v-checkbox>
                                    <v-checkbox :label="$t('Accounting-Code-Empty-Ones')" v-model="Current.Filters.MuhKodBos" hide-details="">
                                    </v-checkbox>
                                    <v-checkbox :label="$t('External-Transfer-Code-Empty-Ones')" v-model="Current.Filters.DisAktarimBos" hide-details=""></v-checkbox>
                                    <v-checkbox :label="$t('Ones-with-Expense-Centre-Explanation')" v-model="Current.Filters.MasrafMerkeziTanimli" hide-details=""></v-checkbox>
                                    <v-checkbox :label="$t('All-Companies')" v-model="tumsirketler" hide-details=""></v-checkbox>

                                </div>

                            </div>
                        </v-layout>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                        <v-btn color="blue darken-1" flat @click="getCurrents(Query.q)">{{ $t('Apply-Filters') }} </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-layout>

        <loadingcomp v-model="denemestatus"></loadingcomp>

        <template>

            <template>
                <v-card>
                    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                        {{ text1 }}
                        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
                    </v-snackbar>
                </v-card>
            </template>
        </template>
    </v-layout>
</v-card>
</template>

<script>
import imageler from '../../../assets/images/arkman.png'
import auth from '../../../api/auth'
import tool from "../coper/tools";
import loadingcomp from "@/components/app/customcomp/loadingcomp"
import helpers from "@/components/app/customcomp/helpers.js"
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
import cariaracomp from '@/components/app/customcomp/cariaracomp'

export default {
    data() {
        return {
            PB:"TRY",
            sayfayetki: {
                Screen: false,
                Update: false,
                Save: false,
                Delete: false,
                Status: false,
                Message: null,
                islem: 0,
            },

            prevRoute: null,

            tumsirketler: null,
            loadingcaribas: false,
            statecaribas: [],
            searchcaribas: null,
            loadingcaribit: false,
            statecaribit: [],
            searchcaribit: null,
            loadingcariana: false,
            statecariana: [],
            searchcariana: null,

            Current: {
                c: null,
                q: null,
                Filters: {
                    BaslangicCari: null,
                    BitisCari: null,
                    AnaHeseap: null,
                    HesapGrubu: [],
                    AnalizKodu: null,
                    Masraf: null,
                    CariTip: '0', //0:hepsi, 1 : bireysel, 2 : Kurumsal
                    HesapGrupBos: false,
                    MuhKodBos: false,
                    DisAktarimBos: false,
                    MasrafMerkeziTanimli: false
                }
            },

            denemestatus: false,
            searchcari: null,
            analiz: [],
            masrafmerkezi: [],
            hesapgurubu: [],
            statecari: [],
            musteritipi: [{
                text: this.$t('Individual'),
                value: 'B'
            }, {
                text: this.$t('Corporate'),
                value: 'K'
            }],
            dialogfiltre: false,
            tooltip: false,
            el: null,
            loading: false,
            items: [],
            search: null,
            kayitvarmi: false,
            Currents: [],
            progress: false,
            progress1: true,

            kayit: false,
            toplamkayit: this.$t('No-Records-Found'),
            kayitlar: false,
            snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            text1: '',
            Query: {
                q: '',
                c: ''
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from.path
        })
    },
    components: {
        loadingcomp,
        yetkidialog,
        cariaracomp
    },
    watch: {
        'Query.q': getCurrents,
        //'Query.q': tumListe,
    },
    mounted() {
        this.$validator.localize('en', this.dictionary)
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.PB=credentials.ParaBirimi
        this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
        
        if (this.sayfayetki.Status == true) {

        } else {

            this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

                if (sonuc == true) {

                    if (this.prevRoute != null) {
                        var url = '#' + this.prevRoute

                        window.open(url, '_self')
                    } else {
                        var url = '#/'
                        window.open(url, '_self')
                    }
                } else {

                }

            });

        }

    },
    methods: {
        tumkayitlar() {
            var url = '#/cari/tumkayitlar/'

            window.open(url, '_self')
        },

        yeniekle() {
            var url = '#/cari/yeni/'

            window.open(url, '_self')
        },
        filtreiptal() {
            this.Current.Filters.BaslangicCari = null
            this.Current.Filters.BitisCari = null
            this.Current.Filters.AnaHeseap = null
            this.Current.Filters.AnalizKodu = null
            this.Current.Filters.Masraf = null
            this.Current.Filters.HesapGrubu = []
            this.Current.Filters.CariTip = '0' //0:hepsi, 1 : bireysel, 2 : Kurumsal
            this.Current.Filters.HesapGrupBos = false
            this.Current.Filters.MuhKodBos = false
            this.Current.Filters.DisAktarimBos = false
            this.Current.Filters.MasrafMerkeziTanimli = false
            this.tumsirketler = false
            this.dialogfiltre = false
        },
        filtrele() {
            this.dialogfiltre = true;
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            var params = {
                CompanyCode: credentials.SirketKodu
            }

            this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.hesapgurubu = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })

            this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.masrafmerkezi = response.body
            }, (response) => {
                if (response.status === 0) {

                } else {

                }
            })

            this.$http.post(auth.API_URL + 'api/Analysis/List', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.progress = false
                this.analiz = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.progress = false
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.progress = false
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })

        },
        efaturaSorgula() {
            var prm = {};

            this.denemestatus = true;
            tool.api_post(this, "EFatura/VKN_SorgulaTumu", prm).then(

                response => {
                    this.denemestatus = false;
                    this.text1 = response.body + ' adet cari hesap için E-Fatura sorgulama işlemi yapılmıştır.';
                    this.snackbar = true;
                },
                response => {
                    this.denemestatus = false;
                }
            );
        },
        getCurrents: getCurrents,
        //  getCurrents2: getCurrents2,


        tumListe: tumListe
    }
}

function getCurrents(e) {
    this.dialogfiltre = false

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.kayitvarmi = false
    if (e.length >= 3) {
        this.progress = true
        this.progress1 = false

        this.Current.q = e
        this.Current.c = credentials.SirketKodu

        this.$http.post(auth.API_URL + 'api/Options/CurrentBoxSearch', this.Current, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            this.Currents = response.body
            this.toplamkayit = this.$t('Total') + ':' + response.body.length + this.$t('number-records-listed')

            if (response.body.length > 0) {
                this.kayitvarmi = true
            } else {
                this.kayitvarmi = false
                this.toplamkayit = this.$t('No-Records-Found')
            }
            this.kayit = false
            this.kayitlar = true
            this.progress = false
            this.progress1 = true
        }, (response) => {
            if (response.status === 0) {
                this.progress = false
                this.progress1 = true
                this.kayitvarmi = false

                this.text1 = 'Service Unavailable'
                this.snackbar = true
            } else {
                this.Currents = []
                this.kayitvarmi = false

                this.kayit = true
                this.Error = response.statusText
            }
        })
    } else if (e.length === 0) {
        this.kayit = true
        this.kayitlar = false
        this.toplamkayit = this.$t('No-Records-Found')

        this.progress = false
        this.Currents = []
    } else {
        this.text1 = 'Service Unavailable'
        this.kayitlar = false
        this.toplamkayit = this.$t('No-Records-Found')
        this.progress = false
        this.Currents = []
    }
}

function tumListe(e) {
    this.kayitvarmi = false
    if (e.length >= 3) {
        var findStr = '%' + e + '%'
        this.Current.Code = findStr
        this.progress = true

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler == true) {
            this.Current.CompanyCode = 0
        } else {
            this.Current.CompanyCode = credentials.SirketKodu
        }

        var params = this.Current
        this.$http.post(auth.API_URL + 'api/Current/List', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {

            this.Currents = response.body
            this.toplamkayit = this.$t('Total') + ':' + response.body.length + this.$t('number-records-listed')

            if (response.body.length > 0) {
                this.kayitvarmi = true
            } else {
                this.kayitvarmi = false
                this.toplamkayit = this.$t('No-Records-Found')
            }
            this.kayit = false
            this.kayitlar = true
            this.progress = false
            this.progress1 = true

        }, (response) => {
            if (response.status === 0) {
                this.progress = false

            } else {
                this.progress = false

            }
        })
        this.dialogfiltre = false
    }
}
</script>

<style>

</style>
